import { contrastRatio } from '@yola/yola-palette-generator';
import reduceColorPointByRatio from '../../../../../common/utils/reduce-color-point-by-ratio';
import increaseOpacity from '../../../../../common/utils/increase-opacity';

const dark = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor } = params;
  const fallback = {
    rule: 'secondaryButton.lightGray.background.default.dark',
    params,
  };

  if (contrastRatio(backgroundColor, targetColorPalette[50]) >= 1.3) {
    return reduceColorPointByRatio({
      targetColor: backgroundColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.3,
      fallback,
    });
  }
  return increaseOpacity({
    targetColor: whiteColor,
    backgroundColor: targetColor,
    opacity: 0.01,
    condition: (ratio) => ratio >= 1.3,
    fallback,
  });
};

export default dark;
